module.exports = __webpack_public_path__ + "static/media/svg-7.d71c7357.svg";